import { Navigate, Route, Routes } from 'react-router-dom';
import { AlreadyOnboardedGuard } from '@/components/AlreadyOnboardedGuard/AlreadyOnboardedGuard';
import { MobileOnlyGuard } from '@/components/MobileOnlyGuard/MobileOnlyGuard';
import { ErrorPage } from '@/Pages/ErrorPage';
import { IdentifyPage } from '@/Pages/Identify/IdentifyPage';
import { InvitePage } from '@/Pages/Invite/InvitePage';
import { MobilePage } from '@/Pages/MobilePage';
import { LinkTokenRoute } from '@/routes/LinkTokenRoute';
import { ParentalConsentPage } from '@/Pages/ParentalConsent/ParentalConsentPage';
import { SelfiePage } from '@/Pages/SelfiePage';
import { SelfieValidationPage } from '@/Pages/SelfieValidationPage';
import { SignupPage } from '@/Pages/SignupPage';
import { SuccessPage } from '@/Pages/SuccessPage';
import { TermsPage } from '@/Pages/TermsPage';
import { WelcomePage } from '@/Pages/WelcomePage';
import { TenantSlugRoute } from '@/routes/TenantSlugRoute';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/welcome" replace />} />
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/terms" element={<TermsPage />} />
      {/* Modo evento: identificação por CPF logo após os termos. */}
      <Route path="/identify" element={<IdentifyPage />} />
      {/* Link único de convite (sem CPF na lista): guarda o token e entra no funil.
          Produção: /<event-slug>/link/<token> (o bootstrap resolve o slug do path);
          /link/<token> puro fica como fallback de dev (?evento=). */}
      <Route path="/link/:token" element={<LinkTokenRoute />} />
      <Route path="/:tenantSlug/link/:token" element={<LinkTokenRoute />} />
      {/* Tela única do convite: escolha de papel antes da selfie do titular,
          grupo (biometria pronta + acompanhantes) depois dela. */}
      <Route path="/invite" element={<InvitePage />} />
      <Route path="/mobile" element={<MobilePage />} />
      {/* Biometria já cadastrada → comprovante. O guard vem ANTES do
          MobileOnlyGuard para não mandar ninguém ao QR à toa. */}
      <Route
        path="/selfie"
        element={
          <AlreadyOnboardedGuard>
            <MobileOnlyGuard>
              <SelfiePage />
            </MobileOnlyGuard>
          </AlreadyOnboardedGuard>
        }
      />
      <Route
        path="/selfie/validating"
        element={
          <AlreadyOnboardedGuard>
            <MobileOnlyGuard>
              <SelfieValidationPage />
            </MobileOnlyGuard>
          </AlreadyOnboardedGuard>
        }
      />
      <Route
        path="/signup"
        element={
          <AlreadyOnboardedGuard>
            <MobileOnlyGuard>
              <SignupPage />
            </MobileOnlyGuard>
          </AlreadyOnboardedGuard>
        }
      />
      {/* `/companions` virou a tela do grupo dentro de `/invite` — o redirect
          cobre histórico, QR e links antigos ainda em circulação. */}
      <Route path="/companions" element={<Navigate to="/invite" replace />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="/parental-consent" element={<ParentalConsentPage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/:tenantSlug" element={<TenantSlugRoute />} />
      <Route
        path="*"
        element={
          <Navigate
            to="/error"
            replace
            state={{ errorType: 'not_found' }}
          />
        }
      />
    </Routes>
  );
}
